<!-- eslint-disable max-len -->
<template>
  <div class="main-content flex-1 bg-gray-100 mt-20 md:mt-20 pb-50 md:pb-5 overflow-y-scroll">

    <div class="flex flex-wrap">
      <div class="w-full p-3">
        <div
          class="bg-gray-400 border-b-2 border-gray-500 rounded-tl-lg rounded-tr-lg p-2"
        >
          <h5 class="font-bold uppercase text-gray-600">Subscription Verify Student </h5>
        </div>
        <div class="overflow-y-auto">
          <div style="margin-bottom: 10px">
            <el-row class="px-5 py-2 " >
              <el-col :span="24" class="flex flex-row justify-end">

              </el-col>
            </el-row>
          </div>

          <data-tables-server ref="tableTransaction" :data="data" :total="total" :pagination-props="{ background: true,pageSizes: [displayingItem] }" @query-change="onChangeTable" >
            <el-table-column v-for="title in titles" :prop="title.prop" :label="title.label" :key="title.prop" sortable="custom">
            </el-table-column>
            <el-table-column label="Actions" align="right" min-width="100px">
              <template slot-scope="scope">
                <div class="static inline-block text-left container-action">
                </div>
              </template>
            </el-table-column>
          </data-tables-server>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import moment from 'moment';

const displayingItems = 50;

export default {
  name: 'SubscriptionVerifyStudentPage',
  data() {
    return {
      isLoading: false,
      isShowingModalAdd: false,
      utc_offset: Math.floor(moment().utcOffset() / 60),
      data: [],
      total: 0,
      displayingItem: displayingItems,
      titles: [{
        prop: 'student_name',
        label: 'Name',
      }, {
        prop: 'email',
        label: 'Email',
      }, {
        prop: 'date',
        label: 'Registered at',
      }, {
        prop: 'city',
        label: 'City',
      }, {
        prop: 'status',
        label: 'Status',
      }],
      filter: {
        page: 1,
        per_page: displayingItems,
        q: '',
        sortby: 'id',
        sortorder: 'desc',
      },
    };
  },
  async mounted() {
    this.toggleDashboardProfile(false);
    await this.requestListVerifyStudent(this.filter);
  },
  computed: {
    ...mapGetters('SubscriptionModule', ['list_verify_student']),
  },
  watch: {
    list_verify_student: {
      immediate: true,
      // eslint-disable-next-line no-unused-vars
      async handler(val) {
        if (this.list_verify_student.data !== undefined) {
          this.data = this.list_verify_student.data.data;
          this.total = this.list_verify_student.data.total;
        }
      },
    },
  },
  methods: {
    ...mapActions('SubscriptionModule', ['requestListVerifyStudent']),
    async search() {
      await this.requestListVerifyStudent(this.filter);
    },
    moment(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    async reset() {
      this.$refs.tableTransaction.$refs.elTable.clearSort();
      this.filter = {
        page: 1,
        per_page: this.displayingItem,
        sortby: 'id',
        sortorder: 'desc',
        q: '',
      };
      this.search();
    },
    async onChangeTable(queryInfo) {
      if (queryInfo.type === 'init') return;
      const pageSize = queryInfo.pageSize;
      this.displayingItem = pageSize;
      const page = queryInfo.page;
      let sortby = queryInfo.sort.prop;
      let sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      if (typeof (sortby) === 'undefined') {
        sortby = 'id';
      }
      sortorder = queryInfo.sort.order === 'descending' || typeof (queryInfo.sort.order) === 'undefined' ? 'asc' : 'desc';
      this.filter = Object.assign(this.filter, { per_page: this.displayingItem, sortorder, sortby, page });
      await this.requestListVerifyStudent(this.filter);
    },
  },
  components: {
    VueCustomTooltip,
  },
};
</script>
<style>
.daterangepicker .calendars{
  display:flex !important;
}
</style>
<style scoped>
.z-1000{
  z-index: 1000;
}
.mx-400{
  max-height: 50%;
  height: 50vh;
}
</style>



// WEBPACK FOOTER //
// src/views/SubscriptionVerifyStudent.vue